import classNames from "classnames";
import React, { useEffect, useState, useRef } from "react";
import { Col, Row } from "react-bootstrap/lib";
import { useDispatch, useSelector } from "../../state/hooks";
import { useSelector as useGlobalSelector } from "react-redux";
import { ReactSVG } from "react-svg";
import {  selectFavoriteSearchCounts, selectFavoriteSearches, selectFilterByKey, selectLeadList, selectLocalFilter, selectLocation, setFavoriteItem, selectFavoriteSelectedName, selectAvailableListingTypes } from "../../state/search";
import {
  updateFilter,
  updateLocalFilter
} from "../../state/search";
import newsearchfilter from "app/Search/Header/searchFilterNew/SearchFilterNew.scss";
import { LeadListScreen, leftPanelKeys } from "app/Search/Header/searchFilterNew/shared/ConstantsNew";
import { useFilter } from "app/Search/Header/searchFilterNew/TagFilterContext";
import { useFilterState } from "../../state/FilterStateContext";
import { getSearchPanelIcons } from "components/common/PropertyFilterIcon";

export const LeadList = () => {

  const { selectedTags, filteredFields, navIndex } = useFilter();
  const getLocalFilter = useSelector(selectLocalFilter);

  const getFavoriteSelectedName = useSelector(selectFavoriteSelectedName);
  const availableListingTypes = useSelector(selectAvailableListingTypes);
  
  const getSelectLocation = useSelector(selectLocation);

  // When the modal is opened from a property group, the Lead List tiles mirror
  // that group's CarouselTile set (passed in as leadListOptions). Otherwise fall
  // back to the full lead-list catalog filtered by available listing types.
  const { leadListOptions } = useFilterState();
  const usingGroupOptions = !!(leadListOptions && leadListOptions.length);
  const listingTypeOptions = usingGroupOptions
    ? leadListOptions
    : LeadListScreen?.fields?.options?.filter(({ value }) => availableListingTypes.includes(value));
  
  const refs = useRef({});
 
  const getSelectFilterlistingType = useSelector(state =>
    selectFilterByKey(state, LeadListScreen?.fields?.name)
  );


  const dispatch = useDispatch();
  const [selected, setSelected] = useState("");

  // Lead-list / favorite counts are global reference data (tied to the current
  // location + the user's saved favorite searches), not part of the modal's
  // private filter-editing slice, so they are read from the global redux store.
  const getLeadList = useGlobalSelector(selectLeadList);
  const getFavoriteSearches = useGlobalSelector(selectFavoriteSearches).toJS();
  const getFavoriteCounts = useGlobalSelector(selectFavoriteSearchCounts).toJS();

  
  const leadListsFilter = getLocalFilter.find(filter => filter.id === 'Lead Lists');

  const leadListsFilterName = leadListsFilter ? leadListsFilter.name : null;

  const filteredOptions = selectedTags.length > 0 ? LeadListScreen.fields.options.filter(option =>
    (option.tag && option.tag.some(tag => selectedTags.includes(tag))) ||
    (leadListsFilterName && option.label === leadListsFilterName) // Include the Lead Lists filter option
  ) : LeadListScreen.fields.options;



  useEffect(() => {
    if (getSelectFilterlistingType && getSelectFilterlistingType.value) {
      setSelected(getSelectFilterlistingType.value);
    } else {
      setSelected("");
    }
  }, [getSelectFilterlistingType]);

  useEffect(() => {
    if (selected) {
      const selectedItem = listingTypeOptions.find(option => (option.value === getFavoriteSelectedName?.listingType && option?.label === getFavoriteSelectedName?.name));
      if (selectedItem) {
        updateFilterLead(selectedItem);
      }
    }
  }, [selected]);

  useEffect(() => {
    const highlightedField = Object.keys(filteredFields).find(field => filteredFields[field] === navIndex);
    if (highlightedField && refs.current[highlightedField]) {
      refs.current[highlightedField].focus({ preventScroll: true });
      refs.current[highlightedField].scrollIntoView({ behavior: 'smooth', block: 'center' });
    }
  }, [filteredFields, navIndex]);


  const updateFilterLead = item => {
    const key = LeadListScreen.fields.name;
    dispatch(updateFilter({ [key]: item.value }));
    dispatch(
      updateLocalFilter([
        {
          key: leftPanelKeys.LeadLists,
          id: "Lead Lists",
          name: item.label,
          option: item,
          apiKey: key,
          removeID: key,
          showALLDisplayValue: item.label
        }
      ])
    );

    // to update selected Favorite Active
    dispatch(setFavoriteItem(item));
    
  };

  // A lead list selection is mandatory in the custom filter editor, so there is
  // no deselect path here (unlike the Search page). Clicking the active tile is a
  // no-op; only switching to another tile changes the selection.
  const isLeadActive = (item) =>
    (getFavoriteSelectedName?.value === item.value &&
      getFavoriteSelectedName?.label === item.label) ||
    (getFavoriteSelectedName?.listingType === item.value &&
      getFavoriteSelectedName?.name === item.label);


  // this flow will come when user select Favorite list it need to update here also
    useEffect(() => {
      // Only the favorite-search flow carries a `listingType` here. The seeded /
      // clicked selection is option-shaped (has `value`, no `listingType`), so
      // guarding on listingType prevents this effect from matching the carousel's
      // undefined-value tiles and clobbering the pre-selected tile.
      if (getFavoriteSelectedName && getFavoriteSelectedName.listingType) {
        let updateSelectedName = listingTypeOptions.find(
          list => (list?.value === getFavoriteSelectedName?.listingType)
        );
        if (updateSelectedName) {
          updateFilterLead(updateSelectedName);
        } else {
          const favoriteSearch = Object.entries(getFavoriteSearches).find(
            ([key, value]) => (value?.listingType === getFavoriteSelectedName?.listingType)
          );
          const listingType = favoriteSearch ? favoriteSearch[1]?.listingType : undefined;
          if (listingType) {
            const selectedItem = listingTypeOptions.find(
              option => (option?.value === listingType)
            );
            if (selectedItem) {
              updateFilterLead(selectedItem);
            }
          }
        }
      }
    }, [getFavoriteSelectedName, getSelectLocation, getFavoriteSearches]);
  

  const getCount = (filter, index) => {
    const count = getLeadList?.find((listitem) => listitem?.searchType === filter.value);
    if (count) {
      return count?.totalCount != 0 ? count?.totalCount.toLocaleString() : getCountFavoriteSearches(filter).toLocaleString();
    }
    return getCountFavoriteSearches(filter).toLocaleString();
  };

  const getCountFavoriteSearches = (filter) => {
    const countEntry = Object.entries(getFavoriteSearches).find(([key, value]) => value.searchType === filter.value);
    if (countEntry) {
      const favoriteCount = getFavoriteCounts[countEntry[1].id];
      return favoriteCount ? favoriteCount : 0;
    }
    return 0;
  };

  // For group (carousel) options the count is already computed on the tile
  // (item.count = quantity); otherwise derive it from the lead-list catalog data.
  const getTileCount = (item, index) => {
    if (usingGroupOptions) {
      return item.count != null ? item.count.toLocaleString() : '0';
    }
    return getCount(item, index);
  };

  const renderLeadListItems = () => {
    // Group (carousel) options keep their given order for a 1:1 match with the
    // group page; the catalog fallback stays alphabetical.
    const orderedOptions = [...listingTypeOptions].sort((a, b) =>
      a.label.localeCompare(b.label)
    );
    return orderedOptions
      .map((item, index) => {
        const selectLead = () => {
          // Mandatory selection: never deselect, only switch.
          if (!isLeadActive(item)) {
            updateFilterLead(item);
          }
        };
        return (
          // <Col key={index} lg={4} md={6} xs={12} className={newsearchfilter.col}>
          <Col key={index} xl={3} lg={3} md={4} xs={12} className={newsearchfilter.col}>
            <div
              className={classNames(newsearchfilter.clsLeadList, {
                [newsearchfilter.active]: isLeadActive(item)
              })}
              onClick={selectLead}
              onKeyDown={(event) => {
                if (event.key === "Enter") {
                  selectLead();
                }
              }}
              ref={el => refs.current[item.label + '_lead'] = el}
              tabIndex={0}
            >
              <div className={newsearchfilter.clsListIcon}>
                <ReactSVG
                  src={getSearchPanelIcons(item.label)}
                  className={newsearchfilter.svgIcon}
                />
              </div>
              <div className={newsearchfilter.clsLeadData}>
                <p className={classNames(newsearchfilter.clsLeadLabel, {
                  [newsearchfilter.clsFilteredLeadLabel]: filteredFields[item.label + '_lead'] !== undefined,
                  [newsearchfilter.highlightOrange]: filteredFields[item.label + '_lead'] === navIndex
                })}>{item.label}</p>
                <p className={newsearchfilter.clsLeadValue}> {getTileCount(item, index)} </p>
              </div>
            </div>
          </Col>
        );
      });
  };


  return (
    // <div className={newsearchfilter.clsRightBodyScroll}>
    <>
      {/* {filteredOptions.length > 0 || selectedTags.length === 0 ? ( */}
        <div className={newsearchfilter.clsContentBody}>
          <div className={newsearchfilter.headerBg}>
            <h2
              className={classNames(
                newsearchfilter.clsHeading,
                newsearchfilter.m_0
              )}
            >
              Lead Lists
            </h2>
          </div>
          <Row className={classNames(newsearchfilter.row)}>
            {renderLeadListItems()}
          </Row>
        </div>
      {/* ) : null} */}
    </>
  );
};
